import { jsx as _jsx } from "react/jsx-runtime";
import { observer } from 'mobx-react-lite';
import { Box } from '@mui/material';
import { useNavigate } from 'react-router';
import linkNavigator from '../../portal/common/linkNavigator';
import BackgroundImage from './BackgroundImage';
import { EditorToolbar, WysiwygInPlaceEditor, WysiwygProvider } from '../wysiwyg/WysiwygInPlaceEditor';
import { serialize, WysiwygViewer } from '../wysiwyg/WysiwygEditor';
import PlaceHolder from '../../portal/common/PlaceHolder';
const HeaderWidget = ({ content, verticalAlignment, horizontalAlignment, backgroundColor, color, backgroundImage, link, editData, configId, opacity, margin, padding, limitToPageWidth, disabled = false, }) => {
    const navigate = useNavigate();
    const isEmpty = () => (!backgroundImage?.assetId && !content.slate && editData);
    if (isEmpty() && editData.activeConfigId !== configId) {
        return (_jsx(PlaceHolder, { placeHolderName: "Configure Header", backgroundColor: backgroundColor }));
    }
    return (_jsx(Box, { sx: {
            position: 'relative',
            backgroundColor,
            color: color || '',
            textAlign: horizontalAlignment,
            cursor: (link && link.type !== 'none') ? 'pointer' : 'inherit',
            margin: {
                marginLeft: `${margin.left || 0}px`,
                marginRight: `${margin.right || 0}px`,
                marginTop: `${margin.top || 0}px`,
                marginBottom: `${margin.bottom || 0}px`,
            },
            padding: {
                paddingLeft: `${padding.left || 0}px`,
                paddingRight: `${padding.right || 0}px`,
                paddingTop: `${padding.top || 0}px`,
                paddingBottom: `${padding.bottom || 0}px`,
            },
            ...(limitToPageWidth && {
                maxWidth: 1200,
                marginX: 'auto',
                width: '100%',
            }),
        }, onClick: (ev) => {
            linkNavigator(link, editData ? (l) => editData.preNavigationHook(l, ev) : navigate);
        }, children: _jsx(BackgroundImage, { backgroundImage: backgroundImage, opacity: opacity, alignItems: verticalAlignment, children: _jsx(Box, { sx: {
                    position: 'relative',
                    textAlign: horizontalAlignment,
                    verticalAlign: verticalAlignment,
                }, children: (editData && editData.activeConfigId === configId && !disabled) ? (_jsx(WysiwygInPlaceEditor, { id: configId })) : (_jsx(WysiwygViewer, { id: configId, value: content.slate })) }) }) }));
};
HeaderWidget.defaultProps = {
    content: {
        slate: undefined,
        html: '<div>&nbsp;</div>',
    },
    disabled: false,
};
HeaderWidget.meta = {
    group: 'design',
    name: 'Header',
    sort: 20,
    description: 'Component displays Header.',
    props: [
        {
            key: 'backgroundImage',
            name: 'Upload Image',
            type: 'backgroundImage',
            description: 'Image to appear behind text.',
        },
        {
            key: 'limitToPageWidth',
            name: 'Limit To Max Page Width',
            type: 'boolean',
            description: 'Limit the width of the stack to the maximum page width',
            group: 'style',
        },
        {
            key: 'layout',
            name: 'Layout',
            type: 'layout',
            description: 'Layout properties such as spacing and background color.',
            group: 'style',
        },
        {
            key: 'opacity',
            name: 'Opacity',
            type: 'opacity',
            description: 'Change the Opacity of background.',
            group: 'style',
        },
        {
            key: 'content',
            name: 'Enter Overlay',
            type: 'richtext',
            inPlaceEdit: true,
            description: '',
            group: 'style',
        },
        {
            key: 'horizontalAlignment',
            name: 'Horizontal Alignment',
            type: 'horizontalAlignment',
            description: 'Horizontal alignment for text and content.',
            group: 'style',
        },
        {
            key: 'verticalAlignment',
            name: 'Vertical Alignment',
            type: 'verticalAlignment',
            description: 'Vertical alignment for text and content.',
            group: 'style',
        },
    ],
    defaultConfig: {
        type: 'component',
        component: 'HeaderWidget',
        props: {
            content: {
                slate: undefined,
                html: '<div>&nbsp;</div>',
            },
            backgroundColor: '',
            limitToPageWidth: true,
            verticalAlignment: 'middle',
            horizontalAlignment: 'left',
            opacity: '1',
            margin: {
                enabled: true,
                top: 0,
                bottom: 0,
                left: 0,
                right: 0,
            },
            padding: {
                enabled: true,
                top: 0,
                bottom: 0,
                left: 0,
                right: 0,
            },
        },
    },
};
HeaderWidget.IpeWrapper = ({ configId, config, editData, children, }) => {
    // console.log('ipewrapper', { configId, config });
    if (!editData || editData.activeConfigId !== configId) {
        return children;
    }
    console.log('doing provider for configId', configId);
    return (_jsx(WysiwygProvider, { id: configId, value: config.props.content ? config.props.content.slate : null, setValue: (newValue) => {
            const newContent = {
                slate: newValue,
                html: serialize(newValue),
            };
            editData.actions.updateConfigValue(configId, 'props.content', newContent);
        }, children: children }));
};
HeaderWidget.ipeControls = (_jsx(EditorToolbar, {}));
HeaderWidget.getData = async ({ backgroundImage, context, }, store) => {
    await BackgroundImage?.getData({ backgroundImage, context }, store);
    return Promise.resolve('ok');
};
export default observer(HeaderWidget);
//# sourceMappingURL=HeaderWidget.js.map